import { parse } from "date-fns";
import * as XLSX from "xlsx";
import { processExcelFile } from "./processExcelFile";

export const generateColumns = (
        startYear,
        endYear,
        startMonth,
        endMonth,
        columns,
        expectedDate,
        totalSum = 'totalSumFormatted',
        useFormatted = false,
        totalFY = false,
        internalColumns,
        hideFYBeforeYear,

) => {

        let expectedYear = null;
        let expectedMonth = null;

        // if (expectedDate) {
        //         const parsed = parse(expectedDate, "dd-MM-yyyy", new Date());
        //         expectedYear = parsed.getFullYear();
        //         expectedMonth = parsed.getMonth() + 1; // 1-based
        // }
        if (expectedDate) {
                let parsed;

                if (expectedDate instanceof Date) {
                        // already Date
                        parsed = expectedDate;
                } else if (typeof expectedDate === "string") {
                        // string → parse
                        parsed = parse(expectedDate, "dd-MM-yyyy", new Date());
                }

                if (parsed && !isNaN(parsed)) {
                        expectedYear = parsed.getFullYear();
                        expectedMonth = parsed.getMonth() + 1;
                }
        }

        const months = [
                'Apr',
                'May',
                'Jun',
                'Jul',
                'Aug',
                'Sep',
                'Oct',
                'Nov',
                'Dec',
                'Jan',
                'Feb',
                'Mar',
        ];

        // Adjust FY loop start for Q4 dates
        const fyStartYear = startMonth <= 3 ? startYear - 1 : startYear;
        const fyEndYear = endMonth <= 3 ? endYear - 1 : endYear;
        let isFirstFY = true;

        for (let year = fyStartYear; year <= fyEndYear; year++) {
                const fyTitle = `FY ${year}-${year + 1}`;
                const fyChildren = [];

                const shortStart = year.toString().slice(-2);
                const shortEnd = (year + 1).toString().slice(-2);

                const fyKey = `${year}-${year + 1}_formatted`;
                fyChildren.push({
                        title: `Total ${shortStart}-${shortEnd}`,
                        dataIndex: fyKey,
                        dataIndex: fyKey,
                        width: 150,
                        align: 'center',
                        className: 'fy-total-column',
                        render: (text) => {
                                let isBeyond = false;

                                if (expectedYear) {
                                        isBeyond = year > expectedYear;
                                }

                                return (
                                        <div
                                                className={`text-right ${isBeyond ? "text-blue-500 font-bold" : ""
                                                        }`}
                                        >
                                                {text}
                                        </div>
                                );
                        },
                });

                for (let q = 0; q < 4; q++) {
                        const quarterMonths = [];

                        for (let m = 0; m < 3; m++) {
                                const monthIndex = q * 3 + m;
                                const monthName = months[monthIndex];

                                // Convert to actual month number (1–12)
                                const actualMonth = (monthIndex + 4) % 12 || 12;
                                const monthYear = actualMonth <= 3 ? year + 1 : year;

                                // ✅ Correct comparison using actual month/year
                                const beforeStart =
                                        monthYear < startYear ||
                                        (monthYear === startYear && actualMonth < startMonth);
                                const afterEnd =
                                        monthYear > endYear ||
                                        (monthYear === endYear && actualMonth > endMonth);

                                if (beforeStart || afterEnd) continue;

                                quarterMonths.push({
                                        title: `${monthName}'${monthYear % 100}`,
                                        dataIndex: useFormatted
                                                ? `${monthName}_${monthYear % 100}_formatted`
                                                : `${monthName}_${monthYear % 100}`,
                                        key: useFormatted
                                                ? `${monthName}_${monthYear % 100}_formatted`
                                                : `${monthName}_${monthYear % 100}`,
                                        align: 'center',
                                        width: 100,
                                        // render: (text) => {
                                        //         return <div className="text-right">{text}</div>;
                                        // },

                                        render: (text) => {
                                                let isBeyond = false;

                                                if (expectedYear && expectedMonth) {
                                                        isBeyond =
                                                                monthYear > expectedYear ||
                                                                (monthYear === expectedYear &&
                                                                        actualMonth > expectedMonth);
                                                }

                                                return (
                                                        <div
                                                                className={`text-right ${isBeyond
                                                                        ? "text-blue-500 font-bold"
                                                                        : ""
                                                                        }`}
                                                        >
                                                                {(text === null || text === undefined || text === '') ? '0.00' : text}
                                                        </div>
                                                );
                                        },
                                });
                        }

                        if (quarterMonths.length > 0) {
                                fyChildren.push({
                                        title: `Q${q + 1}`,
                                        children: quarterMonths,
                                });
                        }
                }
                // Years fully before hideFYBeforeYear are already folded into the
                // Upto column (see getUptoTotal in OtherProjects.jsx) - skip them so
                // their totals aren't shown twice.
                const isHiddenByUpto = hideFYBeforeYear && year < hideFYBeforeYear;

                if (fyChildren.length > 0 && !isHiddenByUpto) {
                        const fyColumn = { title: fyTitle, children: fyChildren };

                        if (isFirstFY && internalColumns?.length > 0) {
                                columns.push(...internalColumns); // Insert internalColumns before FY
                                isFirstFY = false;
                        }

                        columns.push(fyColumn);
                }
        }

        if (!totalFY) {
                columns.push({
                        title: 'Grand Total',
                        dataIndex: totalSum,
                        key: totalSum,
                        width: 150,
                        align: 'center',
                        className: 'grand-total-column',
                        render: (text) => {
                                return <div className="text-right">{text}</div>;
                        },
                });
        }

        return columns;
};

export const parseDMY = (dateStr) =>
        dateStr ? parse(dateStr, "dd-MM-yyyy", new Date()) : null;

export const formatFileSize = (size) => {
        if (size < 1024) return `${size} B`;
        if (size < 1024 * 1024) return `${(size / 1024).toFixed(1)} KB`;
        return `${(size / (1024 * 1024)).toFixed(1)} MB`;
};

export const formatDate = (date) => {
        if (!(date instanceof Date)) return date;

        const day = date.getDate();
        const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
        const month = monthNames[date.getMonth()];
        const year = date.getFullYear();

        return `${day}-${month}-${year}`;  // e.g., 19-Mar-2014
};

export const convertDatesInJson = (rows) => {
        return rows.map(row => {
                const formatted = {};
                for (const key in row) {
                        const value = row[key];
                        formatted[key] = value instanceof Date ? formatDate(value) : value;
                }
                return formatted;
        });
};

export const convertExceltoJson = async (files) => {
        // const allFilesJson = [];

        // for (const file of files) {
        //     const data = await file.arrayBuffer(); //Read File

        //     const workbook = XLSX.read(data);      // Parse workbook

        //     workbook.SheetNames.forEach((sheetName) => {

        //         const worksheet = workbook.Sheets[sheetName];
        //         let sheetJson = XLSX.utils.sheet_to_json(worksheet,
        //             {
        //                 defval: "",
        //                 raw: false,
        //                 cellDates: true
        //             }
        //         );

        //         allFilesJson.push(sheetJson[0]);

        //     });
        // }
        // return allFilesJson;
        const data = await processExcelFile(files[0]);
        return data;
};